import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { fontSize, gridSize } from '@atlaskit/theme/constants';
var height = (gridSize() * 3) / fontSize();
var BreadcrumbsItemElement = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  height: ", "em;\n  line-height: ", "em;\n  padding: 0;\n  box-sizing: border-box;\n  max-width: 100%;\n"], ["\n  display: flex;\n  flex-direction: row;\n  height: ", "em;\n  line-height: ", "em;\n  padding: 0;\n  box-sizing: border-box;\n  max-width: 100%;\n"])), height, height);
BreadcrumbsItemElement.displayName = 'BreadcrumbsItemElement';
export default BreadcrumbsItemElement;
var templateObject_1;
//# sourceMappingURL=BreadcrumbsItem.js.map